// extracted by mini-css-extract-plugin
export default {"section7":"section7_section7__0UrMV","image4":"section7_image4__ihZPy"};